import { TrackerType } from "core/state/Trackers/TrackerType";
import { TrackerChart } from "../../components/Trackers/Charts/TrackerChart";
import { ChartDayOffsets } from "../../components/Trackers/Charts/helpers";
import { useEffect, useState } from "react";
import { useGetUserTrackerValuesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { t } from "i18next";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";

export const StepsTrackerChart = () => {
  const today = new Date();
  const [dateFrom, setDateFrom] = useState<Date>(today.addDays(ChartDayOffsets.week));
  const { fetchTrackerDataFromDate, getCurrentTrackerValue } = useTrackerContext();
  const {
    data: stepsTrackerData,
    mutate,
    isLoading,
    error,
  } = useGetUserTrackerValuesFunctionRequest({
    from: dateFrom.toDateOnlyString(),
    to: today.toDateOnlyString(),
    trackerType: TrackerType[TrackerType.Steps],
  });

  useEffect(() => {
    fetchTrackerDataFromDate(TrackerType.Steps, dateFrom);
  }, [dateFrom, fetchTrackerDataFromDate]);

  useEffect(() => {
    mutate();
  }, [mutate, getCurrentTrackerValue]);

  return (
    <TrackerChart
      trackerType={TrackerType[TrackerType.Steps]}
      heading={t("wellbeing.trackers.steps.chart.heading")}
      dateRange={{ startDate: dateFrom, endDate: today }}
      yAxisStepSize={100}
      yAxisLabel={t("wellbeing.trackers.steps.chart.yLabel")}
      loading={isLoading}
      showError={error !== undefined}
      data={stepsTrackerData?.values ?? []}
      reload={() => mutate()}
      onChartViewOffsetChange={(offset) => setDateFrom(today.addDays(offset))}
      initialChartViewOffset={ChartDayOffsets.week}
    />
  );
};
